import React, { Component } from 'react';
import ProjektTable from "../Components/ProjektTable";
import {isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';
export default class Ordrar extends Component {
    render() {
        return (
            <div className="text-center d-flex flex-column h-100" >
                 <div className="text-center">
                <h2 style={{ paddingTop: '12px', margin: '0',color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}><b><IntlMessages id="DashBoard.Project.Status"/></b></h2>
            </div>
                <div className="d-flex justify-content-center" style={{overflow: 'scroll'}}>
                    <ProjektTable psFontSize={this.props.psFontSize} psFontSize2={this.props.psFontSize2}
                    intervaltype={this.props.intervaltype} FontColor={this.props.FontColor}
                    />
                </div>
                <div className="d-flex justify-content-end w-100" style={{position: 'absolute', bottom: 4, right: 16,color:isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}}>
                    <p>{this.props.getIntervalTypeText(this.props.intervaltype)}</p>
                </div>
            </div>
        )
    }
}